//@flow
import axios from 'axios'

export default (clientId: string) => {
  return axios.get(`/clients/${clientId}`)
}



// WEBPACK FOOTER //
// ./src/api/fetchClient.js